module.exports = __webpack_public_path__ + "media/images/result_sets/circles/2n3r4n8r-f0e7c135d72dc2a013325c2fb678e8ec.svg";